import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PagedData, PaginationData } from '@/Interfaces/_';
import { UserGroupResponse, UserResponse } from '@/Interfaces/I_userGroup';

interface UserGroupsState {
  data: UserGroupResponse[];
  pagination: { total: number; page: number; size: number };
  loading: boolean;
  error: string;
  searched: {
    users: UserResponse[];
    loadingUsers: boolean;
  };
}

const initialState: UserGroupsState = {
  data: [],
  pagination: { total: 0, page: 0, size: 10 },
  loading: false,
  error: '',
  searched: {
    users: [],
    loadingUsers: false,
  },
};

const UserGroupsSlice = createSlice({
  name: 'userGroups',
  initialState,
  reducers: {
    fetchUserGroups: (
      state,
      _action: PayloadAction<{ search?: string; page?: number; size?: number } | undefined>,
    ) => {
      state.loading = true;
      state.error = '';
    },
    setUserGroups: (
      state,
      action: PayloadAction<{
        data: UserGroupResponse[];
        pagination: { total: number; page: number; size: number };
      }>,
    ) => {
      state.data = action.payload.data;
      state.pagination = action.payload.pagination;
      state.loading = false;
      state.error = '';
    },
    setUserGroupsError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    createUserGroup: (state, _action: PayloadAction<{ name: string; description: string }>) => {
      state.loading = true;
    },
    updateUserGroup: (
      state,
      _action: PayloadAction<{ id: number; data: { name: string; description: string } }>,
    ) => {
      state.loading = true;
    },
    deleteUserGroup: (state, _action: PayloadAction<number>) => {
      state.loading = true;
    },
    userGroupSearchUsers: (state, _action: PayloadAction<string>) => {
      state.searched.users = [];
      state.searched.loadingUsers = true;
    },
    setUserGroupSearchUsers: (state, action: PayloadAction<UserResponse[]>) => {
      state.searched.users = action.payload;
      state.searched.loadingUsers = false;
    },
  },
});

export const {
  fetchUserGroups,
  setUserGroups,
  setUserGroupsError,
  createUserGroup,
  updateUserGroup,
  deleteUserGroup,
  userGroupSearchUsers,
  setUserGroupSearchUsers,
} = UserGroupsSlice.actions;

export default UserGroupsSlice.reducer;
